import React from 'react';

type OptionValue = string | number | boolean;

interface OptionButtonsProps {
  label: string;
  options: { value: OptionValue; label: string }[];
  isSelected: (value: OptionValue) => boolean;
  onPick: (value: OptionValue) => void;
}

// The pill buttons shared by yes/no, choice (buttons) and multi_choice.
const OptionButtons: React.FC<OptionButtonsProps> = ({ label, options, isSelected, onPick }) => (
  <div className="report-options" role="group" aria-label={label}>
    {options.map((opt) => (
      <button
        key={String(opt.value)}
        type="button"
        className={`report-option ${isSelected(opt.value) ? 'active' : ''}`}
        aria-pressed={isSelected(opt.value)}
        onClick={() => onPick(opt.value)}
      >
        {opt.label}
      </button>
    ))}
  </div>
);

export default OptionButtons;
